import { normalizeBrazilianDocument } from './normalize';

const INVALID_CPFS = new Set([
  '00000000000',
  '11111111111',
  '22222222222',
  '33333333333',
  '44444444444',
  '55555555555',
  '66666666666',
  '77777777777',
  '88888888888',
  '99999999999',
]);

function calculateCpfCheckDigits(digits: string): string {
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += Number(digits[i]) * (10 - i);
  }
  let remainder = (sum * 10) % 11;
  if (remainder === 10) {
    remainder = 0;
  }
  const firstDigit = String(remainder);

  sum = 0;
  const withFirst = digits.substring(0, 9) + firstDigit;
  for (let i = 0; i < 10; i++) {
    sum += Number(withFirst[i]) * (11 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10) {
    remainder = 0;
  }

  return firstDigit + String(remainder);
}

/** Valida CPF numérico (11 dígitos). */
export function validateCpf(value: string | null | undefined): boolean {
  const cpf = normalizeBrazilianDocument(value);
  if (!/^\d{11}$/.test(cpf) || INVALID_CPFS.has(cpf)) {
    return false;
  }

  const expected = calculateCpfCheckDigits(cpf.substring(0, 9));
  return cpf.endsWith(expected);
}
